import keyMirror from 'fbjs/lib/keyMirror';

/**
 * @namespace Constants
 * @desc App constants
 */

/**
 * @constant {Object} ActionTypes
 * @memberof Constants
 */
export const ActionTypes = keyMirror({
  USER_LOGIN_REQUEST: undefined,
  USER_LOGIN_SUCCESS: undefined,
  USER_LOGIN_FAILURE: undefined,
  USER_LOGOUT_REQUEST: undefined,
  USER_LOGOUT_SUCCESS: undefined,
  USER_LOGOUT_FAILURE: undefined,
  GITHUB_GET_REPOS_REQUEST: undefined,
  GITHUB_GET_REPOS_SUCCESS: undefined,
  GITHUB_GET_REPOS_FAILURE: undefined,
  SHOW_ALERT: undefined,
  HIDE_ALERT: undefined,
  DRAWER_CHANGE: undefined,
  DRAWER_CHANGED: undefined,
  GET_EDGES: undefined,
  GET_EDGES_SUCCESS: undefined,
  GET_EDGES_FAILURE: undefined,
  GET_NODES: undefined,
  GET_NODES_SUCCESS: undefined,
  GET_ALL_NODES_SUCCESS: undefined,
  GET_NODES_FAILURE: undefined,
  GET_TAGS_SUCCESS: undefined,
  SET_TAG_SUCCESS: undefined,
  SET_DETAIL: undefined,
  SET_DETAIL_SUCCESS: undefined,
  SET_DETAIL_FAILURE: undefined,
  CLOSE_INTRO: undefined,
  SHOW_INTRO: undefined,
  GET_HTML: undefined,
  GET_HTML_SUCCESS: undefined,
  GET_HTML_FAILURE: undefined,
  INFO_DRAWER_CHANGE: undefined,
  INFO_DRAWER_CHANGED: undefined,
  GET_NODES_BY_COUNTRY: undefined,
  SET_NODES: undefined,
});

/**
 * @constant {Object} XHR
 * @memberof Constants
 */
export const XHR = keyMirror({
  SUCCESS: undefined,
  FAIL: undefined,
});



// WEBPACK FOOTER //
// ./scripts/constants/index.js